import { useSite } from "@/contexts/SiteContext";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

export default function ExportButton({ kind, label = "Export CSV" }) {
  const { activeSite } = useSite();

  const handle = () => {
    if (!activeSite) return;
    const base = process.env.REACT_APP_BACKEND_URL;
    const url = `${base}/api/export/${kind}?site_id=${activeSite.id}`;
    window.open(url, "_blank");
  };

  return (
    <Button
      data-testid={`export-${kind}-btn`}
      onClick={handle}
      variant="outline"
      className="h-11 gap-2 border-eucalyptus-700 text-eucalyptus-900 hover:bg-eucalyptus-100"
    >
      <Download className="w-4 h-4" />
      {label}
    </Button>
  );
}
